(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aa-claims"] && !Shopify.designMode) return;
  try {
    
// Arrow buttons for the feature rail. Scrolling is the browser's, snap points
// included; this only steps by one card and greys an arrow out at the end.
class AAClaimsRail extends HTMLElement {
  connectedCallback() {
    const head = this.closest('.aa-claims')?.querySelector('.aa-claims__nav');
    if (!head) return;
    this.prev = head.querySelector('[data-claims-prev]');
    this.next = head.querySelector('[data-claims-next]');
    if (!this.prev || !this.next) return;

    const step = () => {
      const card = this.firstElementChild;
      if (!card) return this.clientWidth;
      const gap = parseFloat(getComputedStyle(this).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    };
    this.prev.addEventListener('click', () => this.scrollBy({ left: -step() }));
    this.next.addEventListener('click', () => this.scrollBy({ left: step() }));

    const sync = () => {
      const max = this.scrollWidth - this.clientWidth;
      this.prev.disabled = this.scrollLeft < 4;
      this.next.disabled = this.scrollLeft > max - 4;
    };
    this.addEventListener('scroll', sync, { passive: true });
    new ResizeObserver(sync).observe(this);
    sync();
  }
}
if (!customElements.get('aa-claims-rail')) customElements.define('aa-claims-rail', AAClaimsRail);

// Clips in the carousel run only while their card is on screen, and not at all
// for visitors who ask for less motion.
(function () {
  function start() {
    const clips = document.querySelectorAll('.aa-claims__video');
    if (!clips.length) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        const v = e.target;
        if (e.isIntersecting) {
          if (v.preload === 'none') { v.preload = 'auto'; v.load(); }
          v.play().catch(() => {});
        } else { v.pause(); }
      });
    }, { threshold: 0.4 });
    clips.forEach((v) => io.observe(v));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  var fmt = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD', maximumFractionDigits: 0 });
  document.querySelectorAll('.aa-coll [data-cad]').forEach(function (el) {
    var v = parseFloat(el.getAttribute('data-cad'));
    if (!isNaN(v)) el.textContent = fmt.format(v);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-configure"] && !Shopify.designMode) return;
  try {
    
class ConfigureDome extends HTMLElement {
  connectedCallback() {
    this.webhook = this.dataset.webhook || '';
    this.thankyou = this.dataset.thankyou || '/pages/thank-you';
    this.qty = 1;
    this.lastTotal = 0;
    this.fmt = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD', maximumFractionDigits: 0 });
    this.form = this.querySelector('form');

    if (new URLSearchParams(window.location.search).get('contact_posted') === 'true') {
      const saved = sessionStorage.getItem('aa_quote') || '';
      const sep = this.thankyou.indexOf('?') === -1 ? '?' : '&';
      window.location.replace(this.thankyou + (saved ? sep + 'q=' + encodeURIComponent(saved) : ''));
      return;
    }

    this.sizes = Array.from(this.querySelectorAll('[data-size]'));
    this.opts = Array.from(this.querySelectorAll('[data-opt]'));
    this.airlocks = Array.from(this.querySelectorAll('[data-airlock-opt]'));
    this.linesEl = this.querySelector('[data-lines]');
    this.chipsEl = this.querySelector('[data-sum-chips]');
    this.nameEls = Array.from(this.querySelectorAll('[data-sum-name]'));
    this.tagEls = Array.from(this.querySelectorAll('[data-sum-tag]'));
    this.totalEls = Array.from(this.querySelectorAll('[data-total], [data-total-mobile]'));

    this.sizes.forEach((el) => el.addEventListener('click', () => this.pickSize(el)));
    this.opts.forEach((el) => el.addEventListener('click', () => { if (el.hasAttribute('hidden')) return; el.setAttribute('aria-checked', el.getAttribute('aria-checked') === 'true' ? 'false' : 'true'); this.recompute(); }));
    this.airlocks.forEach((el) => el.addEventListener('click', () => this.pick(this.airlocks, el)));

    const stepper = this.querySelector('[data-stepper]');
    if (stepper) {
      const input = stepper.querySelector('[data-qty]');
      stepper.querySelector('[data-dec]').addEventListener('click', () => { this.qty = Math.max(1, this.qty - 1); input.value = this.qty; this.recompute(); });
      stepper.querySelector('[data-inc]').addEventListener('click', () => { this.qty = Math.min(20, this.qty + 1); input.value = this.qty; this.recompute(); });
    }

    this.initSteps();

    // A configuration handed over from a product page arrives in the address:
    // the size that was picked and the upgrades that were ticked. Honour it and
    // open on the details step, because the choosing already happened on the
    // page the visitor came from. Without a handover, pick the pre-selected
    // size (aria-checked) or the middle one and start at step one.
    const handed = new URLSearchParams(window.location.search);
    const wantFt = (handed.get('size') || '').replace(/[^0-9]/g, '');
    const preset = wantFt ? this.sizes.find((s) => s.dataset.ft === wantFt) : null;

    const start = preset
      || this.sizes.find((s) => s.getAttribute('aria-checked') === 'true')
      || this.sizes[Math.min(3, this.sizes.length - 1)]
      || this.sizes[0];
    if (start) this.pickSize(start);

    if (preset) {
      const qty = parseInt(handed.get('qty'), 10);
      if (qty > 0) {
        this.qty = Math.min(20, qty);
        const input = this.querySelector('[data-qty]');
        if (input) input.value = this.qty;
      }
      const wanted = (handed.get('upgrades') || '').split(',').filter(Boolean);
      if (wanted.length) {
        this.opts.forEach((o) => {
          if (wanted.indexOf(o.dataset.handle) !== -1) o.setAttribute('aria-checked', 'true');
        });
        // The airlock is a choice of one, kept apart from the ticked upgrades;
        // it was dropped on the way over before this.
        const air = this.airlocks.find((a) => a.dataset.handle && wanted.indexOf(a.dataset.handle) !== -1);
        if (air) this.airlocks.forEach((a) => a.setAttribute('aria-checked', a === air ? 'true' : 'false'));
      }
      this.recompute();
      this.goStep(2, true);
    }
    if (this.form) this.form.addEventListener('submit', () => this.onSubmit());
  }

  ft() { const s = this.chosen(this.sizes); return s ? s.dataset.ft : '26'; }
  base() { const s = this.chosen(this.sizes); return s ? parseFloat(s.dataset.base) || 0 : 0; }
  priceFor(el) { const v = el.dataset['p' + this.ft()]; return v === undefined || v === '' ? null : parseFloat(v) || 0; }

  pickSize(el) {
    this.sizes.forEach((o) => o.setAttribute('aria-checked', o === el ? 'true' : 'false'));
    const ft = el.dataset.ft;
    this.showPhoto(el.dataset.img);
    // show/hide + re-price singles for this size
    this.opts.forEach((o) => {
      const p = this.priceFor(o);
      if (p === null) { o.setAttribute('hidden', ''); o.setAttribute('aria-checked', 'false'); }
      else { o.removeAttribute('hidden'); const t = o.querySelector('[data-price-tag]'); if (t) t.textContent = p > 0 ? '+' + this.fmt.format(p) : 'Included'; }
    });
    // airlock radios re-price / availability
    this.airlocks.forEach((o) => {
      const p = this.priceFor(o);
      const tag = o.querySelector('[data-air-tag]');
      if (o.dataset.handle && p === null) { o.setAttribute('hidden', ''); if (o.getAttribute('aria-checked') === 'true') this.airlocks[0].setAttribute('aria-checked', 'true'); }
      else { o.removeAttribute('hidden'); if (tag) tag.textContent = p > 0 ? '+' + this.fmt.format(p) : ''; }
    });
    this.recompute();
  }

  // Swap the summary photo to the chosen size. Preloaded before it is applied
  // so a click never flashes an empty frame, same as the product gallery.
  showPhoto(src) {
    const img = this.querySelector('.aa-geoq__sumimg');
    if (!img || !src || img.dataset.src === src) return;
    img.dataset.src = src;
    let done = false;
    const apply = () => {
      if (done) return;
      done = true;
      img.removeAttribute('srcset');
      img.src = src;
      img.classList.remove('is-loading');
    };
    img.classList.add('is-loading');
    const pre = new Image();
    pre.onload = apply;
    pre.onerror = apply;
    pre.src = src;
    if (pre.complete) apply();
  }

  pick(group, el) { if (el.hasAttribute('hidden')) return; group.forEach((o) => o.setAttribute('aria-checked', o === el ? 'true' : 'false')); this.recompute(); }
  chosen(group) { return group.find((o) => o.getAttribute('aria-checked') === 'true') || group[0]; }

  recompute() {
    const size = this.chosen(this.sizes);
    const ftStr = this.ft();
    const base = this.base();
    const chosenOpts = this.opts.filter((o) => !o.hasAttribute('hidden') && o.getAttribute('aria-checked') === 'true');
    const air = this.chosen(this.airlocks);
    const airUp = air && air.dataset.handle ? (this.priceFor(air) || 0) : 0;
    let optTotal = 0;
    chosenOpts.forEach((o) => { optTotal += this.priceFor(o) || 0; });
    if (airUp > 0) optTotal += airUp;
    const total = (base + optTotal) * this.qty;
    this.lastTotal = total;

    const label = size ? size.dataset.label : 'Growing Dome';
    this.nameEls.forEach((el) => el.textContent = label);
    this.tagEls.forEach((el) => el.textContent = ftStr + 'ft Growing Dome');
    if (this.chipsEl && size) this.chipsEl.innerHTML = '<span class="aa-chip">&#216; ' + ftStr + ' ft</span><span class="aa-chip">' + this.esc(size.dataset.sqft) + ' sq ft</span><span class="aa-chip aa-chip--sage">4 seasons</span>';

    let rows = '<div class="aa-geoq__line"><span>Base structure</span><span class="aa-num">' + this.fmt.format(base) + '</span></div>';
    chosenOpts.forEach((o) => { const p = this.priceFor(o) || 0; rows += '<div class="aa-geoq__line"><span>' + this.esc(o.dataset.label) + '</span><span class="aa-num">' + (p > 0 ? '+' + this.fmt.format(p) : 'Included') + '</span></div>'; });
    if (airUp > 0) rows += '<div class="aa-geoq__line"><span>' + this.esc(air.dataset.label) + '</span><span class="aa-num">+' + this.fmt.format(airUp) + '</span></div>';
    if (this.qty > 1) rows += '<div class="aa-geoq__line"><span>Quantity</span><span class="aa-num">&times; ' + this.qty + '</span></div>';
    if (this.linesEl) this.linesEl.innerHTML = rows;

    this.totalEls.forEach((el) => { if (window.AA && window.AA.countTo) window.AA.countTo(el, total, this.fmt.format); else el.textContent = this.fmt.format(total); });
  }

  initSteps() {
    this.panels = { 1: this.querySelector('[data-panel="1"]'), 2: this.querySelector('[data-panel="2"]') };
    this.stepEls = Array.prototype.slice.call(this.querySelectorAll('.aa-step'));
    if (!this.panels[1] || !this.panels[2]) return;
    this.classList.add('is-stepped');
    this.querySelectorAll('[data-next]').forEach((b) => b.addEventListener('click', () => this.goStep(2)));
    this.querySelectorAll('[data-back]').forEach((b) => b.addEventListener('click', () => this.goStep(1)));
    const start = this.querySelector('.aa-form__err') ? 2 : 1;
    this.goStep(start, true);
  }
  goStep(n, silent) {
    if (!this.panels || !this.panels[n]) return;
    this.panels[1].classList.toggle('is-current', n === 1);
    this.panels[2].classList.toggle('is-current', n === 2);
    this.classList.toggle('is-step2', n === 2);
    this.stepEls.forEach((el) => { const s = Number(el.getAttribute('data-step')); el.classList.toggle('is-active', s === n); el.classList.toggle('is-done', s < n); });
    if (silent) return;
    const steps = this.querySelector('[data-steps]');
    if (steps && steps.scrollIntoView) steps.scrollIntoView({ behavior: 'smooth', block: 'start' });
    const t = n === 2 ? this.querySelector('[data-panel="2"] input') : this.querySelector('[data-next]');
    if (t) { try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); } }
  }

  esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch])); }

  onSubmit() {
    const size = this.chosen(this.sizes);
    const items = [];
    // Names for the CRM (Airtable): the "Name in CRM" of each record, one to one.
    const crm = [];
    this.opts.filter((o) => !o.hasAttribute('hidden') && o.getAttribute('aria-checked') === 'true').forEach((o) => { items.push(o.dataset.label); crm.push(o.dataset.crm || o.dataset.label); });
    const air = this.chosen(this.airlocks);
    if (air && air.dataset.handle) { items.push(air.dataset.label); crm.push(air.dataset.crm || air.dataset.label); }
    this.querySelectorAll('[data-cfg]').forEach((el) => {
      const k = el.dataset.cfg;
      if (k === 'product') el.value = size ? size.dataset.label : 'Growing Dome';
      else if (k === 'size') el.value = size ? size.dataset.ft : '';
      else if (k === 'items') el.value = items.join(', ');
      else if (k === 'qty') el.value = String(this.qty);
      else if (k === 'total') el.value = this.fmt.format(this.lastTotal);
    });
    try { sessionStorage.setItem('aa_quote', JSON.stringify({ title: size ? size.dataset.label : 'Growing Dome', size: size ? size.dataset.ft : '', items: items, qty: this.qty, total: this.lastTotal })); } catch (e) {}
    const payload = {
      product: 'growing-dome', title: size ? size.dataset.label : '', diameter_ft: size ? size.dataset.ft : '', quantity: this.qty,
      kit_size: size ? (size.dataset.crm || size.dataset.label) : '',
      upgrades: crm.join(', '), estimated_total_cad: Math.round(this.lastTotal),
      first_name: this.val('contact[First name]'), last_name: this.val('contact[Last name]'),
      name: (this.val('contact[First name]') + ' ' + this.val('contact[Last name]')).trim(),
      email: this.val('contact[email]'), phone: this.val('contact[phone]'),
      company: this.val('contact[company]'), country: this.val('contact[Country]'),
      postal_code: this.val('contact[Postal code]'), notes: this.val('contact[body]'),
      promo_code: this.val('contact[Referral or promo code]'),
      email_consent: this.consent(),
      form_type: 'quote', form_id: 'growing-dome-configurator', page_url: window.location.href,
      source: 'arcticacres-storefront', submitted_at: new Date().toISOString(),
    };
    // Ad source of the visit (UTM tags, click ids), saved by aa-attribution.js.
    if (typeof window.aaAttribution === 'function') Object.assign(payload, window.aaAttribution());
    if (this.webhook) { try { fetch(this.webhook, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(payload), keepalive: true, mode: 'no-cors' }); } catch (e) {} }
    if (window.dataLayer) window.dataLayer.push({ event: 'generate_lead', form_id: payload.form_id, value: payload.estimated_total_cad, currency: 'CAD', product: payload.title });
    if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', { value: payload.estimated_total_cad, currency: 'CAD' });
  }

  val(name) { const el = this.form && this.form.querySelector('[name="' + name + '"]'); return el ? el.value : ''; }
  consent() { const el = this.form && this.form.querySelector('[data-consent]'); return !!(el && el.checked); }
}
customElements.define('configure-dome', ConfigureDome);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-contact"] && !Shopify.designMode) return;
  try {
    
// The contact form posts to Shopify and emails the store. When a webhook URL is
// set in theme settings, the same submission is also sent as JSON so it can reach
// a CRM. Fire and forget: the native submit is never blocked, and keepalive lets
// the request finish through the page navigation.
class ContactForm extends HTMLElement {
  connectedCallback() {
    this.webhook = this.dataset.webhook || '';
    this.form = this.querySelector('form');
    if (this.form) this.form.addEventListener('submit', () => this.onSubmit());
  }

  val(name) {
    const el = this.form && this.form.querySelector('[name="' + name + '"]');
    if (!el) return '';
    if (el.type === 'checkbox') return el.checked ? 'Yes' : 'No';
    return el.value;
  }

  onSubmit() {
    const payload = {
      form_type: 'contact', form_id: 'contact', product: null,
      page_url: window.location.href,
      first_name: this.val('contact[First name]'), last_name: this.val('contact[Last name]'),
      name: (this.val('contact[First name]') + ' ' + this.val('contact[Last name]')).trim(),
      email: this.val('contact[email]'), phone: this.val('contact[phone]'),
      company: this.val('contact[Company]'), topic: this.val('contact[Topic]'),
      notes: this.val('contact[body]'), newsletter_opt_in: this.val('contact[Newsletter opt-in]'),
      email_consent: this.val('contact[Newsletter opt-in]') === 'Yes',
      source: 'arcticacres-storefront', submitted_at: new Date().toISOString(),
    };
    // Ad source of the visit (UTM tags, click ids), saved by aa-attribution.js.
    if (typeof window.aaAttribution === 'function') Object.assign(payload, window.aaAttribution());
    if (this.webhook) {
      // no-cors keeps this working against any endpoint without CORS setup; that mode
      // only allows a simple content type, so the body is JSON sent as text.
      try { fetch(this.webhook, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(payload), keepalive: true, mode: 'no-cors' }); } catch (e) {}
    }
    if (window.dataLayer) window.dataLayer.push({ event: 'generate_lead', form_id: 'contact', form_type: 'contact' });
    if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', { form_type: 'contact' });
  }
}
customElements.define('contact-form', ContactForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-content"] && !Shopify.designMode) return;
  try {
    
(function () {
  const v = document.querySelector('.aa-content video[data-ambient]');
  if (!v) return;
  const io = new IntersectionObserver((es) => es.forEach((e) => {
    if (e.isIntersecting) { if (v.preload === 'none') { v.preload = 'auto'; v.load(); } v.play().catch(() => {}); } else { v.pause(); }
  }), { threshold: 0.2 });
  io.observe(v);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-gd-overview"] && !Shopify.designMode) return;
  try {
    
(function () {
  const vids = document.querySelectorAll('video[data-ambient]');
  if (!vids.length) return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      const v = e.target;
      if (e.isIntersecting) { if (v.preload === 'none') { v.preload = 'auto'; v.load(); } v.play().catch(() => {}); }
      else { v.pause(); }
    });
  }, { threshold: 0.2 });
  vids.forEach((v) => io.observe(v));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-geo-overview"] && !Shopify.designMode) return;
  try {
    
(function () {
  const vids = document.querySelectorAll('.aa-ov video[data-ambient]');
  if (!vids.length) return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      const v = e.target;
      if (e.isIntersecting) { if (v.preload === 'none') { v.preload = 'auto'; v.load(); } v.play().catch(() => {}); }
      else { v.pause(); }
    });
  }, { threshold: 0.2 });
  vids.forEach((v) => io.observe(v));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-geohome-configurator"] && !Shopify.designMode) return;
  try {
    
class GeoHomeQuote extends HTMLElement {
  connectedCallback() {
    this.base = parseFloat(this.dataset.base) || 0;
    this.title = this.dataset.title;
    this.l = {
      base: this.dataset.lBase || 'Base GeoHome',
      colour: this.dataset.lColour || 'Shell colour',
      included: this.dataset.lIncluded || 'Included',
      qty: this.dataset.lQty || 'Quantity',
    };
    this.diameter = this.dataset.diameter || '';
    this.webhook = this.dataset.webhook || '';
    this.thankyou = this.dataset.thankyou || '/pages/thank-you';
    this.qty = 1;
    this.lastTotal = this.base;
    this.fmt = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD', maximumFractionDigits: 0 });
    this.form = this.querySelector('form');

    // Native contact form succeeded -> carry the stashed config to the thank-you page.
    if (new URLSearchParams(window.location.search).get('contact_posted') === 'true') {
      const saved = sessionStorage.getItem('aa_quote') || '';
      const sep = this.thankyou.indexOf('?') === -1 ? '?' : '&';
      window.location.replace(this.thankyou + (saved ? sep + 'q=' + encodeURIComponent(saved) : ''));
      return;
    }

    this.finishes = Array.from(this.querySelectorAll('[data-finish]'));
    this.layouts = Array.from(this.querySelectorAll('[data-layout]'));
    this.addons = Array.from(this.querySelectorAll('[data-addon]'));
    this.linesEl = this.querySelector('[data-lines]');
    this.totalEls = Array.from(this.querySelectorAll('[data-total], [data-total-mobile]'));

    const bindCard = (group, el) => {
      el.addEventListener('click', () => this.pick(group, el));
      el.addEventListener('keydown', (e) => {
        if (e.target === e.currentTarget && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); this.pick(group, el); }
      });
    };
    this.finishes.forEach((el) => bindCard(this.finishes, el));
    this.layouts.forEach((el) => bindCard(this.layouts, el));
    // Add-ons switch on and off on their own, like a checkbox.
    this.addons.forEach((el) => {
      const toggle = () => { el.setAttribute('aria-checked', el.getAttribute('aria-checked') === 'true' ? 'false' : 'true'); this.recompute(); };
      el.addEventListener('click', (e) => { if (!e.target.closest('.aa-help')) toggle(); });
      el.addEventListener('keydown', (e) => {
        if (e.target === e.currentTarget && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); toggle(); }
      });
    });

    const stepper = this.querySelector('[data-stepper]');
    if (stepper) {
      const input = stepper.querySelector('[data-qty]');
      stepper.querySelector('[data-dec]').addEventListener('click', () => { this.qty = Math.max(1, this.qty - 1); input.value = this.qty; this.recompute(); });
      stepper.querySelector('[data-inc]').addEventListener('click', () => { this.qty = Math.min(20, this.qty + 1); input.value = this.qty; this.recompute(); });
    }

    this.formatTags();
    this.initSteps();
    this.recompute();
    if (this.form) this.form.addEventListener('submit', () => this.onSubmit());
  }

  initSteps() {
    this.panels = { 1: this.querySelector('[data-panel="1"]'), 2: this.querySelector('[data-panel="2"]') };
    this.stepEls = Array.prototype.slice.call(this.querySelectorAll('.aa-step'));
    if (!this.panels[1] || !this.panels[2]) return;
    this.classList.add('is-stepped');
    this.querySelectorAll('[data-next]').forEach((b) => b.addEventListener('click', () => this.goStep(2)));
    this.querySelectorAll('[data-back]').forEach((b) => b.addEventListener('click', () => this.goStep(1)));
    // If the server bounced the submission back with errors, land on step 2 to fix it.
    const start = this.querySelector('.aa-form__err') ? 2 : 1;
    this.goStep(start, true);
  }

  goStep(n, silent) {
    if (!this.panels || !this.panels[n]) return;
    this.panels[1].classList.toggle('is-current', n === 1);
    this.panels[2].classList.toggle('is-current', n === 2);
    this.classList.toggle('is-step2', n === 2);
    this.stepEls.forEach((el) => {
      const s = Number(el.getAttribute('data-step'));
      el.classList.toggle('is-active', s === n);
      el.classList.toggle('is-done', s < n);
    });
    if (silent) return;
    const steps = this.querySelector('[data-steps]');
    if (steps && steps.scrollIntoView) steps.scrollIntoView({ behavior: 'smooth', block: 'start' });
    const t = n === 2
      ? this.querySelector('[data-panel="2"] input, [data-panel="2"] select')
      : this.querySelector('[data-next]');
    if (t) { try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); } }
  }

  pick(group, el) { group.forEach((o) => o.setAttribute('aria-checked', o === el ? 'true' : 'false')); this.recompute(); }
  chosen(group) { return group.find((o) => o.getAttribute('aria-checked') === 'true') || group[0]; }
  picked() { return this.addons.filter((o) => o.getAttribute('aria-checked') === 'true'); }
  formatTags() {
    [...this.finishes, ...this.layouts, ...this.addons].forEach((el) => {
      const p = parseFloat(el.dataset.price) || 0;
      const t = el.querySelector('[data-price-tag]');
      if (t) t.textContent = p > 0 ? '+' + this.fmt.format(p) : this.l.included;
    });
  }

  recompute() {
    const finish = this.chosen(this.finishes);
    const layout = this.chosen(this.layouts);
    const fUp = finish ? parseFloat(finish.dataset.price) || 0 : 0;
    const dUp = layout ? parseFloat(layout.dataset.price) || 0 : 0;
    const addons = this.picked();
    const aUp = addons.reduce((sum, el) => sum + (parseFloat(el.dataset.price) || 0), 0);
    const total = (this.base + fUp + dUp + aUp) * this.qty;
    this.lastTotal = total;
    let rows = '<div class="aa-geoq__line"><span>' + this.esc(this.l.base) + '</span><span class="aa-num">' + this.fmt.format(this.base) + '</span></div>';
    if (finish) {
      const hex = finish.dataset.hex || '#6B7079';
      const sw = finish.dataset.swatch ? ";background-image:url('" + this.esc(finish.dataset.swatch) + "');background-size:100% 100%" : '';
      rows += '<div class="aa-geoq__line"><span class="aa-geoq__swline"><span class="aa-geoq__swdot" style="background-color:' + this.esc(hex) + sw + '"></span>' + this.esc(this.l.colour) + ' (' + this.esc(finish.dataset.label) + ')</span><span class="aa-num">' + (fUp > 0 ? '+' + this.fmt.format(fUp) : this.esc(this.l.included)) + '</span></div>';
    }
    if (dUp > 0) rows += '<div class="aa-geoq__line"><span>' + this.esc(layout.dataset.label) + '</span><span class="aa-num">+' + this.fmt.format(dUp) + '</span></div>';
    addons.forEach((el) => {
      const p = parseFloat(el.dataset.price) || 0;
      rows += '<div class="aa-geoq__line"><span>' + this.esc(el.dataset.label) + '</span><span class="aa-num">' + (p > 0 ? '+' + this.fmt.format(p) : this.esc(this.l.included)) + '</span></div>';
    });
    if (this.qty > 1) rows += '<div class="aa-geoq__line"><span>' + this.esc(this.l.qty) + '</span><span class="aa-num">&times; ' + this.qty + '</span></div>';
    if (this.linesEl) this.linesEl.innerHTML = rows;
    this.totalEls.forEach((el) => {
      if (window.AA && window.AA.countTo) window.AA.countTo(el, total, this.fmt.format);
      else el.textContent = this.fmt.format(total);
    });
  }

  esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch])); }

  onSubmit() {
    const finish = this.chosen(this.finishes);
    const layout = this.chosen(this.layouts);
    const fLabel = finish ? finish.dataset.label : '';
    const lLabel = layout ? layout.dataset.label : '';
    const dividerOn = layout && parseFloat(layout.dataset.price) > 0;
    const addons = this.picked();
    const moduleOn = addons.length > 0;
    // Fill the hidden config fields from the live selection.
    this.querySelectorAll('[data-cfg]').forEach((el) => {
      const k = el.dataset.cfg;
      if (k === 'finish') el.value = fLabel;
      else if (k === 'layout') el.value = lLabel;
      else if (k === 'module') el.value = moduleOn ? 'Yes' : 'No';
      else if (k === 'qty') el.value = String(this.qty);
      else if (k === 'total') el.value = this.fmt.format(this.lastTotal);
    });
    const items = [];
    if (fLabel) items.push('Finish: ' + fLabel);
    if (dividerOn) items.push(lLabel);
    addons.forEach((el) => items.push(el.dataset.label));
    try { sessionStorage.setItem('aa_quote', JSON.stringify({ title: 'GeoHome', size: this.diameter, items: items, qty: this.qty, total: this.lastTotal })); } catch (e) {}
    const payload = {
      product: 'geohome', title: this.title, diameter: this.diameter, quantity: this.qty,
      shell_colour: fLabel, interior_layout: lLabel,
      estimated_total_cad: Math.round(this.lastTotal),
      first_name: this.val('contact[First name]'), last_name: this.val('contact[Last name]'),
      name: (this.val('contact[First name]') + ' ' + this.val('contact[Last name]')).trim(),
      email: this.val('contact[email]'), phone: this.val('contact[phone]'),
      company: this.val('contact[company]'), country: this.val('contact[Country]'),
      postal_code: this.val('contact[Postal code]'), notes: this.val('contact[body]'),
      promo_code: this.val('contact[Referral or promo code]'),
      email_consent: this.consent(),
      form_type: 'quote', form_id: 'geohome-configurator', page_url: window.location.href,
      source: 'arcticacres-storefront', submitted_at: new Date().toISOString(),
    };
    // Ad source of the visit (UTM tags, click ids), saved by aa-attribution.js.
    if (typeof window.aaAttribution === 'function') Object.assign(payload, window.aaAttribution());
    // Only sent while the GeoHab module is on offer, so the payload is unchanged otherwise.
    if (this.addons.length) payload.geohab_module = moduleOn;
    if (this.webhook) {
      try { fetch(this.webhook, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(payload), keepalive: true, mode: 'no-cors' }); } catch (e) {}
    }
    if (window.dataLayer) window.dataLayer.push({ event: 'generate_lead', form_id: payload.form_id, value: payload.estimated_total_cad, currency: 'CAD', product: 'GeoHome' });
    if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', { value: payload.estimated_total_cad, currency: 'CAD' });
  }

  val(name) { const el = this.form && this.form.querySelector('[name="' + name + '"]'); return el ? el.value : ''; }
  consent() { const el = this.form && this.form.querySelector('[data-consent]'); return !!(el && el.checked); }
}
customElements.define('geohome-quote', GeoHomeQuote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-header"]) return;
  try {
    
class AAHeader extends HTMLElement {
  connectedCallback() {
    const burger = this.querySelector('[data-burger]');
    const drawer = this.querySelector('[data-drawer]');
    const scrim = this.querySelector('[data-scrim]');
    const closeBtn = this.querySelector('[data-close]');
    // Drop the header's backdrop-filter while the drawer is open: backdrop-filter makes
    // .aa-hd a containing block for fixed descendants, which would otherwise trap the
    // fixed drawer inside the 76px header box instead of filling the viewport.
    const open = () => { drawer.classList.add('open'); this.classList.add('is-menu-open'); drawer.setAttribute('aria-hidden', 'false'); burger.setAttribute('aria-expanded', 'true'); if (window.aaScrollLock) window.aaScrollLock.lock(); };
    const close = () => { drawer.classList.remove('open'); this.classList.remove('is-menu-open'); drawer.setAttribute('aria-hidden', 'true'); burger.setAttribute('aria-expanded', 'false'); if (window.aaScrollLock) window.aaScrollLock.unlock(); };
    if (burger && drawer) {
      burger.addEventListener('click', open);
      if (scrim) scrim.addEventListener('click', close);
      if (closeBtn) closeBtn.addEventListener('click', close);
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
      // A link to a section of the page the visitor is already on (#submit)
      // does not reload, so the menu closes itself.
      drawer.addEventListener('click', (e) => { if (e.target.closest('a[href]')) close(); });
    }
    const onScroll = () => this.classList.toggle('aa-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    // Publish the real header height. Anything sticky below the header offsets
    // itself by --header-h, and the hard-coded token drifts from the rendered
    // height as soon as the bar's padding or the logo changes.
    const publishHeight = () => {
      const h = Math.round(this.getBoundingClientRect().height);
      if (h > 0) document.documentElement.style.setProperty('--header-h', h + 'px');
    };
    publishHeight();
    if (window.ResizeObserver) new ResizeObserver(publishHeight).observe(this);
    else window.addEventListener('resize', publishHeight, { passive: true });

    // Native Shopify search: toggle panel + live suggestions from /search/suggest.
    const sToggle = this.querySelector('[data-search-toggle]');
    const sPanel = this.querySelector('[data-search]');
    if (sToggle && sPanel) {
      const sInput = sPanel.querySelector('[data-search-input]');
      const sResults = sPanel.querySelector('[data-search-results]');
      const sClose = sPanel.querySelector('[data-search-close]');
      const openS = () => { sPanel.hidden = false; sToggle.setAttribute('aria-expanded', 'true'); requestAnimationFrame(() => { sPanel.classList.add('open'); if (sInput) sInput.focus(); }); };
      const closeS = () => { sPanel.classList.remove('open'); sToggle.setAttribute('aria-expanded', 'false'); setTimeout(() => { sPanel.hidden = true; }, 200); };
      sToggle.addEventListener('click', () => { if (sPanel.hidden) { openS(); } else { closeS(); } });
      if (sClose) sClose.addEventListener('click', closeS);
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !sPanel.hidden) closeS(); });
      const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
      let t;
      if (sInput && sResults) {
        sInput.addEventListener('input', () => {
          const q = sInput.value.trim();
          clearTimeout(t);
          if (q.length < 2) { sResults.innerHTML = ''; return; }
          t = setTimeout(() => {
            fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,page,article&resources[limit]=6')
              .then((r) => r.json())
              .then((d) => {
                const rs = (d.resources && d.resources.results) || {};
                const items = [].concat(rs.products || [], rs.pages || [], rs.articles || []);
                if (!items.length) { sResults.innerHTML = '<div class="aa-search__empty">' + esc(sResults.dataset.empty || '') + '</div>'; return; }
                sResults.innerHTML = items.map((it) => '<a class="aa-search__result" href="' + esc(it.url) + '">' + esc(it.title) + '</a>').join('');
              })
              .catch(() => {});
          }, 180);
        });
      }
    }
  }
}
customElements.define('aa-header', AAHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-hub-hero"] && !Shopify.designMode) return;
  try {
    
// The hero clip loads only once it is on screen and pauses when it leaves, so
// it never competes with the page's first paint. Visitors who ask for less
// motion keep the still picture.
(function () {
  function start() {
    var vids = document.querySelectorAll('.aa-hh__video');
    if (!vids.length) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      vids.forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (v.preload === 'none') { v.preload = 'auto'; v.load(); }
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else { v.pause(); }
      });
    }, { threshold: 0.2 });
    vids.forEach(function (v) { io.observe(v); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-lf-form"] && !Shopify.designMode) return;
  try {
    
// Same pattern as the contact form: Shopify gets the native submit, and when a
// webhook is set in theme settings the request also goes out as JSON, fire and
// forget, marked form_id "lockframe" so Make can tell it from a dome quote.
if (!customElements.get('lockframe-form')) {
  customElements.define('lockframe-form', class extends HTMLElement {
    connectedCallback() {
      this.webhook = this.dataset.webhook || '';
      this.form = this.querySelector('form');
      if (this.form) this.form.addEventListener('submit', () => this.onSubmit());
    }
    val(name) {
      if (!this.form) return '';
      const els = this.form.querySelectorAll('[name="' + name + '"]');
      for (const el of els) {
        if (el.type === 'radio' || el.type === 'checkbox') { if (el.checked) return el.value; continue; }
        return el.value;
      }
      return '';
    }
    onSubmit() {
      const first = this.val('contact[First name]'); const last = this.val('contact[Last name]');
      const payload = {
        form_type: 'lockframe', form_id: 'lockframe', product: 'lockframe',
        page_url: window.location.href,
        first_name: first, last_name: last, name: (first + ' ' + last).trim(),
        email: this.val('contact[email]'), phone: this.val('contact[phone]'),
        company: this.val('contact[Company]'),
        project_stage: this.val('contact[Project stage]'),
        project_location: this.val('contact[Project location]'),
        project_size: this.val('contact[Approximate size]'),
        project_timeline: this.val('contact[Target timeline]'),
        drawings_link: this.val('contact[Drawings link]'),
        notes: this.val('contact[body]'),
        source: 'arcticacres-storefront', submitted_at: new Date().toISOString(),
      };
      // Ad source of the visit (UTM tags, click ids), saved by aa-attribution.js.
      if (typeof window.aaAttribution === 'function') Object.assign(payload, window.aaAttribution());
      if (this.webhook) {
        try { fetch(this.webhook, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(payload), keepalive: true, mode: 'no-cors' }); } catch (e) {}
      }
      if (window.dataLayer) window.dataLayer.push({ event: 'generate_lead', form_id: 'lockframe', form_type: 'lockframe' });
      if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', { form_type: 'lockframe' });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-media-points"] && !Shopify.designMode) return;
  try {
    
// A Shopify-hosted film behind a still with a large play button: the file is
// requested only on the click, then plays with the usual controls.
if (!customElements.get('aa-vid')) {
  customElements.define('aa-vid', class extends HTMLElement {
    connectedCallback() {
      const btn = this.querySelector('button');
      if (btn) btn.addEventListener('click', () => this.play(), { once: true });
    }
    play() {
      if (!this.dataset.src) return;
      const v = document.createElement('video');
      v.controls = true; v.playsInline = true; v.preload = 'auto';
      v.setAttribute('aria-label', this.dataset.title || 'Video');
      const s = document.createElement('source');
      s.src = this.dataset.src; s.type = this.dataset.type || 'video/mp4';
      v.appendChild(s);
      this.replaceChildren(v);
      const p = v.play();
      if (p && p.catch) p.catch(() => {});
      v.focus();
    }
  });
}
// Short clips on the points play muted while they are on screen, and not at
// all for visitors who ask for less motion.
(() => {
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const clips = document.querySelectorAll('video[data-clip]');
  if (!clips.length || !('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver((list) => list.forEach((e) => {
    const v = e.target;
    if (e.isIntersecting) { const p = v.play(); if (p && p.catch) p.catch(() => {}); } else v.pause();
  }), { threshold: 0.35 });
  clips.forEach((v) => io.observe(v));
})();

// A YouTube film behind a still: the player, and everything YouTube loads with
// it, arrives only when the visitor presses play.
if (!customElements.get('aa-yt')) {
  customElements.define('aa-yt', class extends HTMLElement {
    connectedCallback() {
      const btn = this.querySelector('button');
      if (btn) btn.addEventListener('click', () => this.play(), { once: true });
    }
    play() {
      const id = this.dataset.id;
      if (!id) return;
      const f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1';
      f.title = this.dataset.title || 'Video';
      f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      f.allowFullscreen = true;
      f.referrerPolicy = 'strict-origin-when-cross-origin';
      this.replaceChildren(f);
      f.focus();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-product-configurator"] && !Shopify.designMode) return;
  try {
    
class ProductConfigurator extends HTMLElement {
  connectedCallback() {
    this.base = parseFloat(this.dataset.base) || 0;
    this.size = this.dataset.size;
    this.handle = this.dataset.handle;
    this.title = this.dataset.title;
    this.quoteUrl = this.dataset.quoteUrl;
    this.qty = 1;
    this.lastTotal = this.base;
    this.fmt = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD', maximumFractionDigits: 0 });

    this.singles = Array.from(this.querySelectorAll('[data-opt]'));
    this.airlockCard = this.querySelector('[data-airlock]');
    this.airlockOpts = Array.from(this.querySelectorAll('[data-airlock-opt]'));
    this.linesEl = this.querySelector('[data-lines]');
    this.totalEls = Array.from(this.querySelectorAll('[data-total], [data-total-mobile]'));
    this.ctas = Array.from(this.querySelectorAll('[data-cta]'));

    this.singles.forEach((el) => {
      // Native <button> already fires click on Space/Enter; no extra keydown handler
      // (a second path double-toggles aria-checked and no-ops for keyboard users).
      el.addEventListener('click', () => this.toggleSingle(el));
    });
    this.airlockOpts.forEach((el) => el.addEventListener('click', () => this.selectAirlock(el)));

    // Gallery: thumbnails, arrows and touch swipe all drive one showImage(idx).
    this.mainImg = this.querySelector('.aa-cfg__stage .aa-cfg__img');
    this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
    this.countEl = this.querySelector('[data-count]');
    this.curImg = 0;
    // Preload before swapping so a click never flashes an empty frame.
    this.swapImage = (src) => {
      const el = this.mainImg;
      if (!el || !src) return;
      let settled = false;
      const done = () => {
        if (settled) return;
        settled = true;
        el.removeAttribute('srcset');
        el.src = src;
        el.classList.remove('is-loading');
      };
      el.classList.add('is-loading');
      const pre = new Image();
      pre.onload = done;
      pre.onerror = done;
      pre.src = src;
      if (pre.complete) done();
    };
    this.showImage = (idx) => {
      if (!this.thumbs.length) return;
      idx = (idx + this.thumbs.length) % this.thumbs.length;
      if (idx === this.curImg) return;
      const t = this.thumbs[idx];
      this.swapImage(t.dataset.full);
      this.thumbs.forEach((x) => x.classList.remove('is-active'));
      t.classList.add('is-active');
      if (this.countEl) this.countEl.textContent = idx + 1;
      this.curImg = idx;
    };
    this.thumbs.forEach((t, idx) => t.addEventListener('click', () => this.showImage(idx)));
    const galPrev = this.querySelector('[data-gal-prev]');
    const galNext = this.querySelector('[data-gal-next]');
    if (galPrev) galPrev.addEventListener('click', () => this.showImage(this.curImg - 1));
    if (galNext) galNext.addEventListener('click', () => this.showImage(this.curImg + 1));
    const stage = this.querySelector('.aa-cfg__stage');
    if (stage && this.thumbs.length > 1) {
      let sx = 0, sy = 0;
      stage.addEventListener('touchstart', (e) => { sx = e.changedTouches[0].clientX; sy = e.changedTouches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.showImage(this.curImg + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    const stepper = this.querySelector('[data-stepper]');
    if (stepper) {
      const input = stepper.querySelector('[data-qty]');
      stepper.querySelector('[data-dec]').addEventListener('click', () => { this.qty = Math.max(1, this.qty - 1); input.value = this.qty; this.recompute(); });
      stepper.querySelector('[data-inc]').addEventListener('click', () => { this.qty = Math.min(20, this.qty + 1); input.value = this.qty; this.recompute(); });
    }
    this.ctas.forEach((c) => c.addEventListener('click', (e) => { e.preventDefault(); window.location.href = this.buildQuoteUrl(); }));
    this.formatPrices();
    this.recompute();
  }

  // Render every option price in CAD, independent of the store's base currency.
  formatPrices() {
    this.singles.forEach((el) => {
      const p = parseFloat(el.dataset.price) || 0;
      const pe = el.querySelector('.aa-optcard__price');
      if (pe) pe.textContent = '+' + this.fmt.format(p);
    });
    this.airlockOpts.forEach((el) => {
      const p = parseFloat(el.dataset.price) || 0;
      const num = el.querySelector('.aa-num');
      if (num && p > 0) num.textContent = '+' + this.fmt.format(p);
    });
  }

  toggleSingle(el) {
    el.setAttribute('aria-checked', el.getAttribute('aria-checked') === 'true' ? 'false' : 'true');
    this.recompute();
  }
  selectAirlock(el) {
    this.airlockOpts.forEach((o) => o.setAttribute('aria-checked', o === el ? 'true' : 'false'));
    const active = parseFloat(el.dataset.price) > 0;
    if (this.airlockCard) this.airlockCard.classList.toggle('is-on', active);
    this.recompute();
  }
  selected() {
    const list = [];
    this.singles.forEach((el) => { if (el.getAttribute('aria-checked') === 'true') list.push({ handle: el.dataset.handle, label: el.dataset.label, crm: el.dataset.crm, price: parseFloat(el.dataset.price) || 0 }); });
    const air = this.airlockOpts.find((o) => o.getAttribute('aria-checked') === 'true');
    if (air && parseFloat(air.dataset.price) > 0) list.push({ handle: air.dataset.handle, label: air.dataset.label, crm: air.dataset.crm, price: parseFloat(air.dataset.price) || 0 });
    return list;
  }
  recompute() {
    const sel = this.selected();
    const optTotal = sel.reduce((s, o) => s + o.price, 0);
    const total = (this.base + optTotal) * this.qty;
    this.lastTotal = total;
    const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    var baseLabel = this.dataset.baseLabel || 'Base structure';
    var qtyLabel = this.dataset.qtyLabel || 'Quantity';
    let rows = '<div class="aa-line"><span>' + baseLabel + '</span><span class="aa-num">' + this.fmt.format(this.base) + '</span></div>';
    sel.forEach((o) => { rows += '<div class="aa-line aa-line--opt"><span>' + esc(o.label) + '</span><span class="aa-num">+' + this.fmt.format(o.price) + '</span></div>'; });
    if (this.qty > 1) rows += '<div class="aa-line"><span>' + qtyLabel + '</span><span class="aa-num">&times; ' + this.qty + '</span></div>';
    if (this.linesEl) this.linesEl.innerHTML = rows;
    this.totalEls.forEach((el) => {
      if (window.AA && window.AA.countTo) window.AA.countTo(el, total, this.fmt.format);
      else el.textContent = this.fmt.format(total);
    });
  }
  buildQuoteUrl() {
    const sel = this.selected();
    const params = new URLSearchParams();
    params.set('product', this.handle);
    params.set('title', this.title || '');
    params.set('size', this.size);
    params.set('qty', String(this.qty));
    params.set('total', String(Math.round(this.lastTotal)));
    if (this.dataset.kit) params.set('kit', this.dataset.kit);
    if (sel.length) {
      params.set('upgrades', sel.map((o) => o.handle).join(','));
      params.set('items', sel.map((o) => o.label).join('|'));
      params.set('crm', sel.map((o) => o.crm || o.label).join('|'));
    }
    const sep = this.quoteUrl.indexOf('?') === -1 ? '?' : '&';
    return this.quoteUrl + sep + params.toString();
  }
}
customElements.define('product-configurator', ProductConfigurator);

/* Policy panels. <dialog> handles focus, Escape and the backdrop; all that is
   left is opening it, closing it, and treating a click on the backdrop as a
   close, which the element does not do on its own. */
(function () {
  function wire() {
    document.querySelectorAll('[data-policy-open]').forEach(function (btn) {
      if (btn.dataset.polReady) return;
      btn.dataset.polReady = '1';
      btn.addEventListener('click', function () {
        var dlg = document.getElementById(btn.getAttribute('data-policy-open'));
        if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
      });
    });
    document.querySelectorAll('.aa-pol__dlg').forEach(function (dlg) {
      if (dlg.dataset.polReady) return;
      dlg.dataset.polReady = '1';
      var close = dlg.querySelector('[data-policy-close]');
      if (close) close.addEventListener('click', function () { dlg.close(); });
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) dlg.close();
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
  document.addEventListener('shopify:section:load', wire);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-quote-form"] && !Shopify.designMode) return;
  try {
    
class QuoteForm extends HTMLElement {
  connectedCallback() {
    this.webhook = this.dataset.webhook || '';
    this.thankyou = this.dataset.thankyou || '/pages/thank-you';
    this.form = this.querySelector('form');
    this.params = new URLSearchParams(window.location.search);
    this.fmt = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD', maximumFractionDigits: 0 });
    // Holds a model chosen from the empty-state picker; when set it stands in for the URL config.
    this.override = null;
    // Handle -> product photo map, plus the server-rendered default already in the <img>.
    try { this.domeImages = JSON.parse((this.querySelector('[data-dome-images]') || {}).textContent || '{}'); } catch (e) { this.domeImages = {}; }
    const img0 = this.querySelector('[data-sum-img]');
    this.defaultImage = img0 ? img0.getAttribute('src') : '';

    // Native contact form succeeded -> carry the stashed config to the thank-you page.
    if (this.params.get('contact_posted') === 'true') {
      const saved = sessionStorage.getItem('aa_quote') || '';
      const sep = this.thankyou.indexOf('?') === -1 ? '?' : '&';
      window.location.replace(this.thankyou + (saved ? sep + 'q=' + encodeURIComponent(saved) : ''));
      return;
    }

    this.renderSummary();
    this.fillHidden();
    this.initStep1();
    this.initSteps();
    if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));
  }

  // Step 1 has two faces: a review of a handed-over configuration, or a model picker
  // for a direct visit. Either way the sticky summary on the right stays in sync.
  initStep1() {
    const hasCfg = !!this.params.get('title');
    const label = this.querySelector('[data-step1-label]');
    const next = this.querySelector('[data-next]');
    const pick = this.querySelector('[data-qpick]');
    const review = this.querySelector('[data-qreview]');

    if (hasCfg) {
      if (review) review.hidden = false;
      const edit = this.querySelector('[data-edit-cfg]');
      if (edit) { const c = this.config(); if (c.product) edit.setAttribute('href', '/products/' + c.product); }
      if (label) label.textContent = 'Review';
      return;
    }

    // Direct visit -> pick a starting model.
    if (label) label.textContent = 'Choose your dome';
    if (!pick) return;
    pick.hidden = false;
    if (next) next.disabled = true;
    const opts = Array.prototype.slice.call(this.querySelectorAll('[data-qopt]'));
    opts.forEach((btn) => {
      btn.addEventListener('click', () => {
        opts.forEach((b) => { b.classList.remove('is-active'); b.setAttribute('aria-checked', 'false'); });
        btn.classList.add('is-active');
        btn.setAttribute('aria-checked', 'true');
        this.override = {
          product: btn.dataset.product || '',
          title: btn.dataset.title || '',
          size: btn.dataset.size || '',
          qty: '1',
          total: btn.dataset.total || '',
          items: [],
          upgrades: [],
          kit: btn.dataset.kit || '',
          crm: [],
        };
        this.renderSummary();
        this.fillHidden();
        if (next) next.disabled = false;
      });
    });
  }

  initSteps() {
    this.panels = {
      1: this.querySelector('[data-panel="1"]'),
      2: this.querySelector('[data-panel="2"]'),
    };
    this.stepEls = Array.prototype.slice.call(this.querySelectorAll('.aa-step'));
    if (!this.panels[1] || !this.panels[2]) return;
    // Opt into stepping only once JS is running, so the form degrades gracefully.
    this.classList.add('is-stepped');

    this.querySelectorAll('[data-next]').forEach((b) => b.addEventListener('click', () => this.goStep(2)));
    this.querySelectorAll('[data-back]').forEach((b) => b.addEventListener('click', () => this.goStep(1)));

    // A handed-over configuration goes straight to the details step (no redundant
    // review click); a direct visit starts on step 1 to pick a model. Validation
    // errors always land on step 2 so the visitor can fix the form.
    const hasCfg = !!this.params.get('title');
    const start = (this.querySelector('.aa-form__err') || hasCfg) ? 2 : 1;
    this.goStep(start, true);
  }

  goStep(n, silent) {
    if (!this.panels || !this.panels[n]) return;
    this.panels[1].classList.toggle('is-current', n === 1);
    this.panels[2].classList.toggle('is-current', n === 2);
    this.stepEls.forEach((el) => {
      const s = Number(el.getAttribute('data-step'));
      el.classList.toggle('is-active', s === n);
      el.classList.toggle('is-done', s < n);
    });
    if (silent) return;
    // Keep the step indicator in view and move focus for keyboard/AT users.
    const steps = this.querySelector('[data-steps]');
    if (steps && steps.scrollIntoView) steps.scrollIntoView({ behavior: 'smooth', block: 'start' });
    const focusTarget = n === 2
      ? this.querySelector('[data-panel="2"] input, [data-panel="2"] select')
      : this.querySelector('[data-next]');
    if (focusTarget) { try { focusTarget.focus({ preventScroll: true }); } catch (e) { focusTarget.focus(); } }
  }

  config() {
    if (this.override) return this.override;
    return {
      product: this.params.get('product') || '',
      title: this.params.get('title') || '',
      size: this.params.get('size') || '',
      qty: this.params.get('qty') || '1',
      total: this.params.get('total') || '',
      items: (this.params.get('items') || '').split('|').filter(Boolean),
      upgrades: (this.params.get('upgrades') || '').split(',').filter(Boolean),
      kit: this.params.get('kit') || '',
      crm: (this.params.get('crm') || '').split('|').filter(Boolean),
    };
  }

  esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
  }

  // Paint the sticky summary card (photo, name, chips, upgrade lines, total).
  renderSummary() {
    const c = this.config();
    const has = !!c.title;

    const img = this.querySelector('[data-sum-img]');
    if (img) {
      const src = (c.product && this.domeImages[c.product]) ? this.domeImages[c.product] : this.defaultImage;
      if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
      if (has) img.setAttribute('alt', c.title);
    }
    this.querySelectorAll('[data-sum-tag]').forEach((el) => { el.textContent = has ? c.title : 'Your dome'; });
    const name = this.querySelector('[data-sum-name]');
    if (name) name.textContent = has ? c.title : 'Tell us about your project';

    const chips = this.querySelector('[data-sum-chips]');
    if (chips) {
      let ch = '';
      if (c.size) ch += '<span class="aa-chip">&#216; ' + this.esc(c.size) + ' ft</span>';
      if (c.qty && c.qty !== '1') ch += '<span class="aa-chip">&times; ' + this.esc(c.qty) + '</span>';
      if (c.items && c.items.length) ch += '<span class="aa-chip aa-chip--sage">' + c.items.length + (c.items.length > 1 ? ' upgrades' : ' upgrade') + '</span>';
      chips.innerHTML = ch;
    }

    const lines = this.querySelector('[data-lines]');
    if (lines) {
      let rows = '';
      (c.items || []).forEach((i) => { rows += '<div class="aa-geoq__line"><span>' + this.esc(i) + '</span><span class="aa-num">Added</span></div>'; });
      lines.innerHTML = rows;
    }

    const row = this.querySelector('[data-total-row]');
    if (row) row.hidden = !c.total;
    const total = this.querySelector('[data-sum-total]');
    if (total && c.total) total.textContent = this.fmt.format(Number(c.total));
    const note = this.querySelector('[data-total-note]');
    if (note) {
      note.textContent = (this.override && (!c.items || !c.items.length))
        ? 'Starting price, in CAD'
        : (has && c.total ? 'Estimated configuration price, in CAD' : 'In CAD, nothing charged now');
    }
  }

  fillHidden() {
    const c = this.config();
    this.querySelectorAll('[data-cfg]').forEach((el) => {
      const k = el.dataset.cfg;
      if (k === 'items') el.value = c.items.join(', ');
      else if (k === 'total') el.value = c.total ? this.fmt.format(Number(c.total)) : '';
      else el.value = c[k] || '';
    });
  }

  onSubmit() {
    // Native form proceeds (email). Fire the webhook + analytics with keepalive so
    // they complete through the page navigation. Do not preventDefault.
    const c = this.config();
    const payload = {
      product: c.product, title: c.title, diameter_ft: c.size, quantity: c.qty,
      // Kit size and upgrades by their "Name in CRM", one to one with Airtable.
      kit_size: c.kit || '', upgrades: (c.crm || []).join(', '),
      estimated_total_cad: c.total ? Number(c.total) : null,
      first_name: this.val('contact[First name]'), last_name: this.val('contact[Last name]'),
      name: (this.val('contact[First name]') + ' ' + this.val('contact[Last name]')).trim(),
      email: this.val('contact[email]'), phone: this.val('contact[phone]'),
      company: this.val('contact[company]'), country: this.val('contact[Country]'),
      postal_code: this.val('contact[Postal code]'),
      notes: this.val('contact[body]'),
      promo_code: this.val('contact[Referral or promo code]'),
      email_consent: this.consent(),
      form_type: 'quote', form_id: 'quote-form', page_url: window.location.href,
      source: 'arcticacres-storefront', submitted_at: new Date().toISOString(),
    };
    // Ad source of the visit (UTM tags, click ids), saved by aa-attribution.js.
    if (typeof window.aaAttribution === 'function') Object.assign(payload, window.aaAttribution());
    try { sessionStorage.setItem('aa_quote', JSON.stringify({ title: c.title, size: c.size, items: c.items, qty: c.qty, total: c.total })); } catch (e) {}
    if (this.webhook) {
      try { fetch(this.webhook, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(payload), keepalive: true, mode: 'no-cors' }); } catch (e) {}
    }
    if (window.dataLayer) window.dataLayer.push({ event: 'generate_lead', form_id: payload.form_id, value: payload.estimated_total_cad, currency: 'CAD', product: c.title });
    if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', { value: payload.estimated_total_cad, currency: 'CAD' });
  }

  val(name) { const el = this.form && this.form.querySelector('[name="' + name + '"]'); return el ? el.value : ''; }
  consent() { const el = this.form && this.form.querySelector('[data-consent]'); return !!(el && el.checked); }
}
customElements.define('quote-form', QuoteForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-story"]) return;
  try {
    
// Swaps the thumbnail for the player on the first click, and not before.
class VideoEmbed extends HTMLElement {
  connectedCallback() {
    var button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', function () {
      var id = this.dataset.video;
      var frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      frame.title = 'Video';
      frame.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
      frame.allowFullscreen = true;
      this.replaceChildren(frame);
    }.bind(this), { once: true });
  }
}
if (!customElements.get('video-embed')) customElements.define('video-embed', VideoEmbed);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-thank-you"] && !Shopify.designMode) return;
  try {
    
class ThankYou extends HTMLElement {
  esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
  }
  connectedCallback() {
    let data = null;
    try {
      const q = new URLSearchParams(window.location.search).get('q');
      data = q ? JSON.parse(decodeURIComponent(q)) : JSON.parse(sessionStorage.getItem('aa_quote') || 'null');
    } catch (e) {}
    if (data && data.title) {
      const box = this.querySelector('[data-recap]');
      const fmt = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD', maximumFractionDigits: 0 });
      // Values come from a URL param, so escape before inserting as HTML.
      let html = '<div class="r-name">' + this.esc(data.title) + '</div>';
      if (data.size) html += '<div class="r-line"><span>Diameter</span><span>' + this.esc(String(data.size).replace(/\s*ft$/i, '')) + ' ft</span></div>';
      (data.items || []).forEach((i) => { html += '<div class="r-line"><span>' + this.esc(i) + '</span><span>Added</span></div>'; });
      if (data.qty && String(data.qty) !== '1') html += '<div class="r-line"><span>Quantity</span><span>&times; ' + this.esc(data.qty) + '</span></div>';
      if (data.total) html += '<div class="r-line r-total"><span>Estimated total</span><span class="aa-num">' + fmt.format(Number(data.total)) + '</span></div>';
      box.innerHTML = html;
      box.hidden = false;
    }
    try { sessionStorage.removeItem('aa_quote'); } catch (e) {}
    if (window.dataLayer) window.dataLayer.push({ event: 'quote_submitted' });
  }
}
customElements.define('aa-thank-you', ThankYou);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
